import React from "react";
import ScreeningQuestionOne from "../shared/ScreeningQuestionOne";
import { handleStoreScreeningScheduledDetails } from "../public/CommonAPIHelper";

const ScreeningScheduledQuestionOneUI = () => {
  return (
    <ScreeningQuestionOne
      questionText="What screening do you have scheduled?"
      backRoute="/questions/1"
      nextRoute="/screeningscheduled/2"
      onSubmitHandler={handleStoreScreeningScheduledDetails}
    />
  );
};

export default ScreeningScheduledQuestionOneUI;
